export default "__VITE_ASSET__ntMCXJvS__"